import React from 'react';
import SEO from '../../components/SEO/SEO';
import { Link } from 'react-router-dom';
import './SEOServices.css';
import seoImage from '../../images/seo.jpg';

const SEOServices = () => {
    const seoServices = [
        {
            id: 'onpage',
            title: 'On-Page SEO',
            subtitle: 'Content & Keyword Optimization',
            description: 'Optimize every element of your web pages for maximum search visibility and user engagement.',
            icon: '📝',
            features: [
                'Keyword Research & Strategy',
                'Content Optimization & Structure',
                'Meta Tags & Schema Markup',
                'Internal Linking & Site Architecture'
            ],
            link: '/services/seo/on-page'
        },
        {
            id: 'offpage',
            title: 'Off-Page SEO',
            subtitle: 'Authority & Link Building',
            description: 'Build authority and trust through strategic link building and digital PR campaigns.',
            icon: '🔗',
            features: [
                'High-Quality Backlink Acquisition',
                'Digital PR & Brand Mentions',
                'Local Citation Building',
                'Social Signals & Engagement'
            ],
            link: '/services/seo/off-page'
        },
        {
            id: 'technical',
            title: 'Technical SEO',
            subtitle: 'Site Performance & Crawlability',
            description: 'Ensure your website is fast, crawlable, and technically sound for search engines.',
            icon: '⚙️',
            features: [
                'Site Speed & Core Web Vitals',
                'Mobile Optimization & Responsiveness',
                'Crawlability & Indexing Issues',
                'Structured Data & Rich Snippets'
            ],
            link: '/services/seo/technical-seo'
        },
        {
            id: 'linkbuilding',
            title: 'Link Building',
            subtitle: 'Authority Growth Strategy',
            description: 'Earn high-quality backlinks that boost your domain authority and search rankings.',
            icon: '🎯',
            features: [
                'Guest Posting & Content Marketing',
                'Broken Link Building & Resource Pages',
                'Competitor Analysis & Gap Opportunities',
                'Link Quality Assessment & Monitoring'
            ],
            link: '/services/seo/link-building'
        }
    ];

    return (<>

        

            <SEO 
                title="S E O Services Services" 
                description="Learn more about our S E O Services services to grow your business online with Digi Network." 
                canonical="/seo/seoservices" 
            />

<div className="seo-services-page">
            {/* Hero Section */}
            <section className="seo-hero">
                <div className="seo-hero-bg"></div>
                <div className="container">
                    <div className="seo-hero-content">
                        <div className="label">SEO SERVICES</div>
                        <h1>Dominate Search Results with Precision SEO</h1>
                        <p className="seo-hero-description">
                            Digi Network helps businesses achieve top search rankings through technical excellence, content optimization, and authority growth. Our comprehensive SEO strategies are designed to drive sustainable organic traffic and maximize conversions.
                        </p>
                        <div className="seo-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get a Free SEO Audit
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">300%</div>
                            <div className="stat-label">Average Organic Traffic Growth</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">#1</div>
                            <div className="stat-label">Average Ranking Position</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">85%</div>
                            <div className="stat-label">Client Retention Rate</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Websites Optimized</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SEO Services Grid */}
            <section className="seo-services-grid-section">
                <div className="container">
                    <div className="section-header">
                        <div className="label">SEO SERVICES</div>
                        <h2>Comprehensive SEO Solutions</h2>
                        <p>We provide end-to-end SEO services that drive sustainable organic growth.</p>
                    </div>

                    <div className="seo-services-grid">
                        {seoServices.map((service) => (
                            <div key={service.id} className="seo-service-card">
                                <div className="seo-service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <div className="seo-service-subtitle">{service.subtitle}</div>
                                <p className="seo-service-description">{service.description}</p>

                                <ul className="seo-service-features">
                                    {service.features.map((feature, index) => (
                                        <li key={index}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <circle cx="10" cy="10" r="10" fill="#0037FC" opacity="0.1"/>
                                                <path d="M6 10L9 13L14 7" stroke="#0037FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                <Link to={service.link} className="btn btn-dark">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why SEO Matters */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="why-seo-content">
                        <div className="why-seo-text">
                            <h2>Why SEO is Essential for Your Business</h2>
                            <div className="why-seo-points">
                                <div className="why-point">
                                    <h4>🎯 Targeted Traffic</h4>
                                    <p>Reach customers actively searching for your products or services — not just anyone, but qualified leads ready to convert.</p>
                                </div>
                                <div className="why-point">
                                    <h4>💰 Cost-Effective</h4>
                                    <p>Unlike paid ads, SEO provides long-term results. Once you rank, you continue to receive organic traffic without ongoing ad spend.</p>
                                </div>
                                <div className="why-point">
                                    <h4>🏆 Credibility & Trust</h4>
                                    <p>Top search rankings signal authority and trustworthiness. Users trust organic results more than paid advertisements.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📈 Measurable ROI</h4>
                                    <p>Track every metric — from rankings and traffic to conversions and revenue. SEO delivers transparent, quantifiable results.</p>
                                </div>
                            </div>
                        </div>
                        <div className="why-seo-visual">
                            <img src={seoImage} alt="SEO Services" className="why-seo-image" />
                        </div>
                    </div>
                </div>
            </section>

            {/* SEO Process */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Proven SEO Process</h2>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Comprehensive Audit</h3>
                            <p>We analyze your website's current performance, identify technical issues, and uncover opportunities for growth.</p>
                        </div>

                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Strategy Development</h3>
                            <p>Custom SEO roadmap aligned with your business goals, target audience, and competitive landscape.</p>
                        </div>

                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Implementation</h3>
                            <p>Execute on-page optimizations, content creation, technical fixes, and link building campaigns.</p>
                        </div>

                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Monitor & Optimize</h3>
                            <p>Continuous tracking, A/B testing, and refinement to maximize rankings and conversions.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="seo-cta">
                <div className="container">
                    <div className="seo-cta-content">
                        <h2>Ready to Dominate Search Results?</h2>
                        <p>Get a free SEO audit and discover how we can boost your rankings and drive organic traffic.</p>
                        <Link to="/contact" className="btn btn-primary">
                            Book Your Free SEO Audit
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
        </>
    );
};

export default SEOServices;
